export const config = {
  api_local: process.env.REACT_APP_API_URL, 
  BE_API_URL: process.env.REACT_APP_API_URL,
  site: process.env.REACT_APP_SITE,
  LIST_BANK_NAME: [ //data NEW88
    'MBBANK',
    'VIETCOMBANK',
    'TPBANK',
    'BIDV BANK',
    'TECHCOMBANK',
    'VIETINBANK',
    'ACB BANK',
    'VPBANK',
    'VIB BANK',
    'PGBANK',
    'AGRIBANK',
    'SACOMBANK',
    'MOMO',
    'MSB BANK',
    'NCB',
    'LIOBANK',
    'MBV',
    'OCB BANK',
    'SHB BANK',
    'KIENLONGBANK',
    'ABBANK',
    'PVCOMBANK',
    'CAKE',
    'LIENVIET BANK',
    'NAMA BANK',
    'HD BANK',
    'VIKKI BANK',
    'SHINHAN BANK VN',
    'TIMO BANK',
    'SEABANK',
    'EXIMBANK',
    'CO OPBANK',
    'WOORI BANK',
    'BAC A BANK',
    'VIETBANK',
    'VIETA BANK',
    'VIET CAPITAL BANK',
    'KBANK',
    'GP BANK',
    'VIKKI BY HDBANK',
    'CIMB BANK',
    'BAO VIET BANK',
    'IVB',
    'UOB',
    'SAIGONBANK',
    'ANZ BANK',
    'HONGLEONG BANK',
    'UBANK',
    'VDB',
    'CB BANK',
    'SCB',
    'HSBC',
    'VIETNAM BANK FOR SOCIAL POLICIES',
    'PBVN',
    'CITI',
    'KOOKMI',
    'VRB(VIET NGA)',
    'IBK',
    'MAFC',
    'DBS',
    'HNB',
    'SCBVL',
  ],
  LIST_REQUEST_BANK: [
    "Xóa ngân hàng",
    "Thêm ngân hàng",
    "Sửa ngân hàng",
    "Thêm Ví USDT",
  ],
  // lựa chọn khi "Sửa ngân hàng"
  LIST_EDIT_BANK: [
    "Sửa tên ngân hàng",
    "Sửa stk ngân hàng",
    "Sửa stk và tên ngân hàng",
  ],
};